import i18n from '../../../../i18n';

export const reasonTypes = [
  { value: 'INSURANCE_CHANGED', label: i18n.t(`INSURANCE_CHANGED`) },
  {
    value: 'INSURANCE_CHANGED_2_MONTHS',
    label: i18n.t(`INSURANCE_CHANGED_2_MONTHS`),
  },
  { value: 'CONTRACT_TERMINATION', label: i18n.t(`CONTRACT_TERMINATION`) },
  { value: 'PREMIUM_INCREASE', label: i18n.t(`PREMIUM_INCREASE`) },
  { value: 'RISK_OBJECT_CHANGED', label: i18n.t(`RISK_OBJECT_CHANGED`) },
];

export const insuranceTypeOptions = [
  { value: 'CAR', label: i18n.t('Car insurance') },
  { value: 'RESIDENCE', label: i18n.t('Home insurance') },
  { value: 'FAMILY', label: i18n.t('Family insurance') },
  { value: 'TWO_WHEELER', label: i18n.t('Motor insurance') },
  { value: 'LEGAL', label: i18n.t('Legal aid insurance') },
  { value: 'BIKE', label: i18n.t('Bike insurance') },
  {
    value: 'INDIVIDUAL_ACCIDENT',
    label: i18n.t('Individual accident insurance'),
  },
];
